const mod = require('../../bahabot.module.js');

function bbDiscordResourceInput($http, $timeout, $element, $document, $filter) {
    const ctrl = this;

    let clickListener;
    const filter = $filter('filter');

    function tag(type, el) {
        el.key = `${type}-${el.id}`;
        return el;
    }

    function adjustChannelData(el) {
        if (el.type == 2) el.name = `[🗣️] ${el.name}`;
        if (el.type == 0) el.name = `[💬] ${el.name}`
    }

    ctrl.$onInit = async function () {
        ctrl.stage = 'guild';
        ctrl.selectedIndex = 0;
        ctrl.query = '';
        ctrl.results = [];
        ctrl.loading = false;
        ctrl.loadError = false;
        // true while a saved value is fetched; the input stays empty until then
        ctrl.restoring = !!(ctrl.model?.startsWith('guild/') || ctrl.guildId);
        ctrl.displayValue = '';
        ctrl.deleted = false;
        ctrl.menuOpen = false;
        ctrl.menuUp = false;
        ctrl.context = {}; // {guild, channel, message, emote}

        ctrl.cut = ctrl.cut || 'message';

        if (ctrl.model?.startsWith('guild/')) {
            await restoreContextFromModel(ctrl.model);
            /*
            if (ctrl.cut === 'guild' && ctrl.context.guild) return ctrl.finalize();
            if (ctrl.cut === 'channel' && ctrl.context.channel) return ctrl.finalize();
            if (ctrl.cut === 'message' && ctrl.context.message) return ctrl.finalize();
            if (ctrl.cut === 'emote' && ctrl.context.emote) return ctrl.finalize();
            */
        }

        if (ctrl.guildId) {
            try {
                ctrl.context.guild = await fetchGuild(ctrl.guildId);
            } catch {
                ctrl.context.guild = null;
                ctrl.displayValue = '[Deleted]';
                ctrl.deleted = true;
                ctrl.model = '';
            }
            if (ctrl.context.guild) {
                ctrl.deleted = false;
                ctrl.displayValue = '';
                ctrl.stage = ctrl.cut === 'guild' ? 'done' : 'channel';
            } else {
                ctrl.stage = 'guild';
            }
        }

        if (ctrl.channelId && ctrl.context.guild) {
            try {
                ctrl.context.channel = await fetchChannel(ctrl.guildId, ctrl.channelId);
            } catch {
                ctrl.context.channel = null;
                ctrl.displayValue = '[Deleted channel]';
                ctrl.deleted = true;
                ctrl.model = '';
            }
            if (ctrl.context.channel) {
                ctrl.deleted = false;
                ctrl.displayValue = '';
                ctrl.stage = ctrl.cut === 'channel' ? 'done' : 'message';
            } else {
                ctrl.stage = 'channel';
            }
        }

        // awaits above resolve outside the digest
        $timeout(() => {
            ctrl.restoring = false;
        });

        if (ctrl.stage !== 'done') {
            ctrl.updateResults();
        } else {
            ctrl.finalize();
        }

        clickListener = (event) => {
            if (!$element[0].contains(event.target)) {
                $timeout(() => {
                    ctrl.menuOpen = false;
                    if (ctrl.model && ctrl.stage !== 'done') {
                        ctrl.finalize();
                    }
                })
            }
        }

        $document.on('click', clickListener)
    };

    ctrl.$onDestroy = function () {
        if (clickListener) {
            $document.off('click', clickListener);
        }
    }

    ctrl.clear = function () {
        ctrl.model = '';
        ctrl.displayValue = '';
        ctrl.deleted = false;
        ctrl.query = '';
        ctrl.results = [];
        ctrl.stage = 'guild';
        ctrl.context = {};
        ctrl.menuOpen = false;
        ctrl.updateResults();
    };

    ctrl.canGoBack = function () {
        if (ctrl.stage === 'done') {
            return ctrl.cut !== 'guild';
        }
        return ['channel', 'message', 'threadMessage', 'emote'].includes(ctrl.stage);
    };

    ctrl.goBack = function () {
        ctrl.displayValue = '';
        ctrl.deleted = false;

        if (ctrl.stage === 'threadMessage') {
            ctrl.context.thread = null;
            ctrl.context.threadMessage = null;
            ctrl.stage = 'message';
        } else if (ctrl.stage === 'message') {
            ctrl.context.message = null;
            ctrl.stage = 'channel';
        } else if (ctrl.stage === 'channel') {
            ctrl.context.channel = null;
            ctrl.stage = 'guild';
        } else if (ctrl.stage === 'emote') {
            ctrl.context.emote = null;
            ctrl.stage = 'guild';
        } else if (ctrl.stage === 'done') {
            if (ctrl.cut === 'message') {
                ctrl.context.message = null;
                if (ctrl.context.threadMessage) {
                    ctrl.context.thread = null;
                    ctrl.context.threadMessage = null;
                }
                ctrl.stage = 'channel';
            } else if (ctrl.cut === 'channel') {
                ctrl.context.guild = null;
                ctrl.stage = 'guild';
            } else if (ctrl.cut === 'emote') {
                ctrl.context.guild = null;
                ctrl.stage = 'guild';
            }
        }

        ctrl.model = '';
        $timeout(() => {
            ctrl.query = '';
            ctrl.results = [];
            ctrl.menuOpen = true;
            ctrl.updateResults();
        });
    };


    ctrl.updateResults = async function () {
        ctrl.loading = true;
        ctrl.loadError = false;
        ctrl.results = [];

        let data = [];
        let failed = false;

        try {
            if (ctrl.stage === 'guild') {
                ({ data } = await $http.get('/api/protected/discord/discover/guilds'));
                data.forEach(d => tag('guild', d))
            } else if (ctrl.stage === 'channel') {
                const gid = ctrl.context.guild?.id || ctrl.guildId;
                ({ data } = await $http.get(`/api/protected/discord/discover/guilds/${gid}/channels`));
                data.forEach(d => {
                    adjustChannelData(d);
                    tag('channel', d)
                })
                data = data.filter(r => r.type !== 4);
            } else if (ctrl.stage === 'emote') {
                const gid = ctrl.context.guild?.id || ctrl.guildId;
                ({ data } = await $http.get(`/api/protected/discord/discover/guilds/${gid}/emotes`));
                data.forEach(d => tag('emote', d))
            } else if (ctrl.stage === 'message') {
                const gid = ctrl.context.guild?.id;
                const cid = ctrl.context.channel?.id;
                ({ data } = await $http.get(`/api/protected/discord/discover/guilds/${gid}/channels/${cid}/messages`));
                data.forEach(d => tag('message', d))
            } else if (ctrl.stage === 'threadMessage') {
                const gid = ctrl.context.guild?.id;
                const cid = ctrl.context.channel?.id;
                const mid = ctrl.context.message?.id;
                ({ data } = await $http.get(`/api/protected/discord/discover/guilds/${gid}/channels/${cid}/messages/${mid}/thread`));
                data.forEach(d => tag('message', d))
            }
        } catch {
            data = [];
            failed = true;
        }

        $timeout(() => {
            ctrl.results = data;
            ctrl.selectedIndex = 0;
            ctrl.loading = false;
            ctrl.loadError = failed;
        });
    };


    ctrl.select = function (item) {
        if (ctrl.stage === 'guild') {
            ctrl.context.guild = item;
            if (ctrl.cut === 'guild') {
                ctrl.finalize();
            } else if (ctrl.cut === 'emote') {
                $timeout(() => {
                    ctrl.stage = 'emote';
                    ctrl.query = '';
                    ctrl.results = [];
                    ctrl.updateResults();
                });
            } else {
                $timeout(() => {
                    ctrl.stage = 'channel';
                    ctrl.query = '';
                    ctrl.results = [];
                    ctrl.updateResults();
                });
            }
        } else if (ctrl.stage === 'channel') {
            ctrl.context.channel = item;
            if (ctrl.cut === 'channel') {
                ctrl.finalize();
            } else {
                $timeout(() => {
                    ctrl.stage = 'message';
                    ctrl.query = '';
                    ctrl.results = [];
                    ctrl.updateResults();
                });
            }
        } else if (ctrl.stage === 'message') {
            ctrl.context.message = item;
            if (item.thread) {
                ctrl.context.thread = item.thread;
                $timeout(() => {
                    ctrl.stage = 'threadMessage';
                    ctrl.query = '';
                    ctrl.results = [];
                    ctrl.updateResults();
                });
            } else {
                ctrl.finalize();
            }
        } else if (ctrl.stage === 'emote') {
            ctrl.context.emote = item;
            ctrl.finalize();
        } else if (ctrl.stage === 'threadMessage') {
            ctrl.context.threadMessage = item;
            ctrl.finalize();
        }
    };


    ctrl.finalize = function () {
        const g = ctrl.context.guild?.id;
        const c = ctrl.context.channel?.id;
        const e = ctrl.context.emote?.id;
        const m = ctrl.context.message?.id;
        const tm = ctrl.context.threadMessage?.id;

        if (ctrl.cut === 'guild') {
            ctrl.model = `guild/${g}`;
            ctrl.displayValue = ctrl.context.guild?.name;
        } else if (ctrl.cut === 'channel') {
            ctrl.model = `guild/${g}/channel/${c}`;
            ctrl.displayValue = ctrl.context.channel?.name;
        } else if (ctrl.cut === 'emote') {
            ctrl.model = `guild/${g}/emotes/${e}`;
            ctrl.displayValue = ctrl.context.emote?.name;
        } else if (ctrl.cut === 'message' && !ctrl.context.threadMessage) {
            ctrl.model = `guild/${g}/channel/${c}/message/${m}`;
            const content = ctrl.context.message?.content || '[No content]';
            ctrl.displayValue = `${ctrl.context.message.author.username}: ${content}`
        } else if (ctrl.cut === 'message' && ctrl.context.threadMessage) {
            ctrl.model = `guild/${g}/channel/${c}/message/${m}/thread/${tm}`;
            const content = ctrl.context.threadMessage?.content || '[No content]';
            ctrl.displayValue = `${ctrl.context.threadMessage.author.username}: ${content}`
        }

        ctrl.stage = 'done';
        ctrl.deleted = false;
        ctrl.menuOpen = false;
    };

    ctrl.filteredResults = function () {
        return filter(ctrl.results, ctrl.query);
    };

    ctrl.onKeyDown = function (e) {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            ctrl.selectedIndex = Math.min(ctrl.selectedIndex + 1, ctrl.results.length - 1);
            $timeout();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            ctrl.selectedIndex = Math.max(ctrl.selectedIndex - 1, 0);
            $timeout();
        } else if (e.key === 'Enter') {
            e.preventDefault();
            const visible = ctrl.filteredResults();
            if (visible.length > 0) {
                ctrl.select(visible[ctrl.selectedIndex]);
            }
        } else if (e.key === 'Backspace' && ctrl.query === '') {
            e.preventDefault();
            if (ctrl.canGoBack()) {
                ctrl.goBack();
            }
        } else if (e.key === 'Escape') {
            e.preventDefault();
            ctrl.menuOpen = false;
            if (ctrl.model && ctrl.stage !== 'done') {
                ctrl.finalize();
            }
            $timeout();
        } else {
            ctrl.selectedIndex = 0;
            ctrl.menuOpen = true;
        }

        $timeout(() => {
            const el = document.getElementById('item-' + ctrl.selectedIndex);
            el?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
    };

    ctrl.onFocus = function () {
        if (ctrl.stage === 'done') {
            ctrl.stage = ctrl.cut;
            ctrl.query = '';
            ctrl.results = [];
            ctrl.menuOpen = true;
            ctrl.updateResults();
        }

        const inputEl = $element[0].querySelector('input');
        const rect = inputEl.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;

        ctrl.menuUp = spaceBelow < 250 && spaceAbove > spaceBelow;
        if (!ctrl.menuOpen) {
            ctrl.menuOpen = true;
        }
    };

    async function restoreContextFromModel(model) {
        const parts = model.split('/');
        const [_, guildId, t2, channelOrEmoteId, ___, messageId, ____, threadMessageId] = parts;

        if (guildId) {
            try {
                ctrl.context.guild = await fetchGuild(guildId);
            } catch {
                ctrl.context.guild = null;
                ctrl.displayValue = '[Deleted]';
                ctrl.deleted = true;
                ctrl.model = '';
                ctrl.stage = 'guild';
                return;
            }
        }

        if (t2 === 'channel' && channelOrEmoteId) {
            try {
                ctrl.context.channel = await fetchChannel(guildId, channelOrEmoteId);
                adjustChannelData(ctrl.context.channel);
            } catch {
                ctrl.context.channel = null;
                ctrl.displayValue = '[Deleted channel]';
                ctrl.deleted = true;
                ctrl.model = '';
                ctrl.stage = 'channel';
                return;
            }
        } else if (t2 === 'emotes' && channelOrEmoteId) {
            try {
                ctrl.context.emote = await fetchEmote(guildId, channelOrEmoteId);
            } catch {
                ctrl.context.emote = null;
                ctrl.displayValue = '[Deleted emote]';
                ctrl.deleted = true;
                ctrl.model = '';
                ctrl.stage = 'emote';
                return;
            }
        }

        if (messageId) {
            try {
                ctrl.context.message = await fetchMessage(guildId, channelOrEmoteId, messageId);
            } catch {
                ctrl.context.message = null;
                ctrl.displayValue = '[Deleted message]';
                ctrl.deleted = true;
                ctrl.model = '';
                ctrl.stage = 'message';
                return;
            }
        }

        if (threadMessageId && ctrl.context.message?.thread) {
            try {
                const threadId = ctrl.context.message.thread.id;
                ctrl.context.thread = await fetchThread(guildId, channelOrEmoteId, messageId);
                ctrl.context.threadMessage = await fetchThreadMessage(guildId, channelOrEmoteId, messageId, threadMessageId);
            } catch {
                ctrl.context.thread = null;
                ctrl.context.threadMessage = null;
                ctrl.displayValue = '[Deleted thread message]';
                ctrl.deleted = true;
                ctrl.model = '';
                ctrl.stage = 'message';
                return;
            }
        }

        $timeout(() => {
            const isAnyComplete =
                (ctrl.cut === 'message' && ctrl.context.threadMessage) ||
                (ctrl.cut === 'message' && ctrl.context.message) ||
                (ctrl.cut === 'channel' && ctrl.context.channel) ||
                (ctrl.cut === 'guild' && ctrl.context.guild) ||
                (ctrl.cut === 'emote' && ctrl.context.emote);

            if (isAnyComplete) {
                ctrl.finalize();
                ctrl.stage = 'done';
            }
        });
    }

    function fetchEmote(gid, eid) {
        return $http.get(`/api/protected/discord/discover/guilds/${gid}/emotes/${eid}`)
            .then(r => ({ id: r.data.id, name: r.data.name }));
    }

    function fetchThread(gid, cid, mid) {
        return $http.get(`/api/protected/discord/discover/guilds/${gid}/channels/${cid}/messages/${mid}/thread`)
            .then(r => ({ id: r.data.id, name: r.data.name }));
    }

    function fetchThreadMessage(gid, cid, mid, tmid) {
        return $http.get(`/api/protected/discord/discover/guilds/${gid}/channels/${cid}/messages/${mid}/thread/${tmid}`)
            .then(r => r.data);
    }

    async function fetchGuild(id) {
        const { data } = await $http.get(`/api/protected/discord/discover/guilds/${id}`);
        return data;
    }

    async function fetchChannel(guildId, channelId) {
        const { data } = await $http.get(`/api/protected/discord/discover/guilds/${guildId}/channels/${channelId}`);
        return data;
    }

    async function fetchMessage(guildId, channelId, messageId) {
        const { data } = await $http.get(`/api/protected/discord/discover/guilds/${guildId}/channels/${channelId}/messages/${messageId}`);
        return data;
    }
}

mod.component('bbDiscordResourceInput', {
    template: `
<div class="relative">
    <input
        type="text"
        ng-attr-id="$ctrl.id"
        ng-model="$ctrl.query"
        ng-keydown="$ctrl.onKeyDown($event)"
        ng-focus="$ctrl.onFocus()"
        ng-value="$ctrl.displayValue"
        placeholder="{{$ctrl.restoring ? 'Loading...' : 'Select ' + ($ctrl.stage === 'threadMessage' ? 'message in thread' : $ctrl.stage)}}"
        ng-disabled="$ctrl.restoring"
        autocomplete="off"
        ng-class="{'line-through text-red-400': $ctrl.deleted}"
        class="w-full px-3 py-2 pr-16 rounded bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-white border border-gray-300 dark:border-slate-700 focus:outline-none focus:ring focus:ring-blue-500"
    />

    <!-- Buttons -->
    <div class="absolute right-2 top-1/2 -translate-y-1/2 flex space-x-2">
        <!-- result loading shows in the open menu -->
        <span ng-if="$ctrl.restoring" class="text-gray-400 dark:text-slate-400 text-lg">
            <i class="fa-solid fa-spinner animate-spin inline-block"></i>
        </span>
        <button ng-if="!$ctrl.restoring && $ctrl.canGoBack()" ng-click="$ctrl.goBack()" class="text-gray-400 dark:text-slate-400 hover:text-red-600 text-lg">
            <i class="fa fa-arrow-left"></i>
        </button>
        <button ng-if="!$ctrl.restoring && ($ctrl.model || $ctrl.deleted)" ng-click="$ctrl.clear()" class="text-gray-400 dark:text-slate-400 hover:text-red-600 text-lg">
            <i class="fa fa-times"></i>
        </button>
    </div>

    <!-- Dropdown Menu -->
    <div ng-if="$ctrl.menuOpen"
        ng-class="{
            'absolute left-0 right-0 z-50 max-h-60 overflow-auto rounded shadow-lg bg-gray-50 dark:bg-slate-900 border border-gray-300 dark:border-slate-700 mt-1': true,
            'bottom-full absolute mb-1': $ctrl.menuUp,
            'top-full absolute mt-1': !$ctrl.menuUp
        }">
        <div ng-if="$ctrl.loading" class="px-3 py-2 text-gray-400 dark:text-slate-400 italic">
            <i class="fa-solid fa-spinner animate-spin inline-block mr-2"></i>Loading {{$ctrl.stage === 'threadMessage' ? 'messages in thread' : $ctrl.stage}}...
        </div>

        <div ng-if="!$ctrl.loading && $ctrl.loadError" class="px-3 py-2 text-red-400 italic">
            Could not load {{$ctrl.stage}}. <button ng-click="$ctrl.updateResults()" class="underline">Retry</button>
        </div>

        <ul ng-if="!$ctrl.loading && $ctrl.results.length > 0">
            <li ng-repeat="item in $ctrl.filteredResults(); track by item.id"
                ng-attr-id="item-{{$index}}"
                ng-click="$ctrl.select(item)"
                ng-class="{'bg-gray-200 dark:bg-slate-700': $index === $ctrl.selectedIndex}"
                class="px-3 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 cursor-pointer flex items-center gap-2">
                
                <img ng-if="$ctrl.stage === 'guild' && item.icon"
                    ng-src="https://cdn.discordapp.com/icons/{{item.id}}/{{item.icon}}.png"
                    class="w-6 h-6 rounded" />

                <img ng-if="($ctrl.stage === 'message' || $ctrl.stage === 'threadMessage') && item.author.avatar"
                    ng-src="https://cdn.discordapp.com/avatars/{{item.author.id}}/{{item.author.avatar}}.png"
                    class="w-6 h-6 rounded" />

                <img ng-if="$ctrl.stage === 'emote'"
                    ng-src="https://cdn.discordapp.com/emojis/{{item.id}}.{{item.animated ? 'gif' : 'png'}}"
                    class="w-6 h-6" />

                <span>
                    <span ng-if="$ctrl.stage === 'guild'">{{item.name}}</span>
                    <span ng-if="$ctrl.stage === 'channel'">{{item.name}}</span>
                    <span ng-if="$ctrl.stage === 'message' || $ctrl.stage === 'threadMessage'">
                        <strong>{{item.author.username}}:</strong> {{item.content || '[No content]'}}
                    </span>
                    <span ng-if="$ctrl.stage === 'emote'">:{{item.name}}:</span>
                </span>
            </li>
        </ul>

        <div ng-if="!$ctrl.loading && $ctrl.results.length === 0 && $ctrl.query.length > 0"
             class="px-3 py-2 text-gray-500 dark:text-slate-500 italic">
            No matches found.
        </div>
    </div>
</div>
    `,
    bindings: {
        guildId: "@",
        channelId: "@",
        cut: "@",
        id: "@",
        model: "="
    },
    controller: ['$http', '$timeout', '$element', '$document', '$filter', bbDiscordResourceInput]
});
